/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Geo_Dim_CitabilityInputs */

const en_directory_hubs_signals_geo_dim_citability = /** @type {(inputs: Directory_Hubs_Signals_Geo_Dim_CitabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answer-shaped content: question-style headings, answer-first sections, lists, and statistics that engines can extract cleanly.`)
};

const zh_directory_hubs_signals_geo_dim_citability = /** @type {(inputs: Directory_Hubs_Signals_Geo_Dim_CitabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容是答案形状的：疑问式标题、开门见山的回答、列表与数据，让引擎干净地摘录。`)
};

/**
* | output |
* | --- |
* | "Answer-shaped content: question-style headings, answer-first sections, lists, and statistics that engines can extract cleanly." |
*
* @param {Directory_Hubs_Signals_Geo_Dim_CitabilityInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_geo_dim_citability = /** @type {((inputs?: Directory_Hubs_Signals_Geo_Dim_CitabilityInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Geo_Dim_CitabilityInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_geo_dim_citability(inputs)
	return zh_directory_hubs_signals_geo_dim_citability(inputs)
});
export { directory_hubs_signals_geo_dim_citability as "directory.hubs.signals.geo.dim.citability" }